import { ADMIN_SELECT_ENTITY_PATH, ROOT_PATH } from 'routes/paths'
import type { LocationType } from '../'
import type { UserState } from 'utils/hooks/use-userInfo'
import { TEACHER_WITH_MULTIPLE_ENTITIES_HAS_CHOSEN_ENTITY } from 'config/vars'
import { shouldRenderSelectEntity } from 'utils/profile-menu/shouldRenderNotificationPreferences'

function getRedirectLocation(user: UserState, currentPath): LocationType {
  // user can not access page
  if (
    !shouldRenderSelectEntity(user) &&
    currentPath === ADMIN_SELECT_ENTITY_PATH
  ) {
    return { pathname: ROOT_PATH }
  }

  // if yes the teacher must choose an entity
  if (
    shouldRenderSelectEntity(user) &&
    currentPath !== ADMIN_SELECT_ENTITY_PATH &&
    !sessionStorage.getItem(TEACHER_WITH_MULTIPLE_ENTITIES_HAS_CHOSEN_ENTITY)
  ) {
    return { pathname: ADMIN_SELECT_ENTITY_PATH }
  }

  return {
    pathname: ''
  }
}

export default {
  getRedirectLocation
}
